module.exports = __webpack_public_path__ + "img/1272.58d78366.gif";